<template>
  <div class="preview">
    <el-image v-if="type === 'image'" :src="src" fit="contain"></el-image>
    <VideoPlayer v-if="type === 'video'" :src="src" />
  </div>
</template>

<script>
import { getAbsoluteUrl } from './utils'
import VideoPlayer from './Video.vue'
// 视频、图片预览组件
export default {
  name: 'Preview',

  components: {
    VideoPlayer
  },

  props: {
    file: [Object]
  },

  data() {
    return {
      type: '',
      src: ''
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    async init() {
      const { relativeUrl, _type } = this.file
      // 根据相对路径获取绝对路径，防止地址过期
      // const absoluteUrl = await getAbsoluteUrl({ bizType: relativeUrl.split('/')[1], key: relativeUrl })
      this.src = relativeUrl
      this.type = _type
    }
  }
}
</script>

<style lang="stylus" scoped>
.preview
  height: 70vh
  display: flex
  justify-content: center
</style>
